import request, { HttpMethod } from '@app/libs/request';
import { serverUrl } from '@app/config';
import { OrganizationServerResponse } from '@app/domain/userManagement/organizations';
import { ORGANIZATION_HEADER_NAME } from '@app/utils/userIdentityHeadersGenerator';
import { UpdateOrganizationServicesRequest } from '@backee/domain/organizationServices';

export async function updateServicesOfOrganization(
  organizationId: string,
  data: UpdateOrganizationServicesRequest,
): Promise<OrganizationServerResponse> {
  return request<OrganizationServerResponse>(serverUrl, `/api/organizations/services`, {
    data,
    method: HttpMethod.patch,
    headers: {
      [ORGANIZATION_HEADER_NAME]: organizationId,
    },
    errorsHandler: {
      REFERENCED_SERVICE_ERROR: {
        message: ({ tenantUserIdToNames }): string =>
          `Cannot remove a service while these users hold its roles: ${Object.entries(tenantUserIdToNames)
            .map(([tenantUserId, name]) => name ?? tenantUserId)
            .join(', ')}`,
      },
      default: {
        message: 'Cannot update the services of the organization.',
      },
    },
  });
}
